import { create } from 'zustand';

export type Theme = 'night' | 'day';
const KEY = 'souqli-theme';

/** Read the persisted theme, else fall back to the OS preference (default night). */
function initialTheme(): Theme {
  if (typeof window === 'undefined') return 'night';
  const saved = localStorage.getItem(KEY);
  if (saved === 'night' || saved === 'day') return saved;
  // Night Souq is the default; only start in Day if the OS explicitly prefers light.
  return window.matchMedia?.('(prefers-color-scheme: light)').matches ? 'day' : 'night';
}

/** Reflect the theme onto <html data-theme> so the CSS variables switch. */
function apply(theme: Theme) {
  if (typeof document !== 'undefined') document.documentElement.setAttribute('data-theme', theme);
}

interface ThemeState {
  theme: Theme;
  setTheme: (t: Theme) => void;
  toggle: () => void;
}

export const useTheme = create<ThemeState>((set, get) => {
  const theme = initialTheme();
  apply(theme);
  return {
    theme,
    setTheme: (t) => { apply(t); try { localStorage.setItem(KEY, t); } catch {} set({ theme: t }); },
    toggle: () => get().setTheme(get().theme === 'night' ? 'day' : 'night'),
  };
});
